import {
  COLLECTION_LIST_REQUESTING,
  GET_COLLECTION_SUCCESS,
  LIST_COLLECTIONS_SUCCESS,
  RESET_COLLECTION_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  query: [],
  isListFetching: false,
  isObjectFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_COLLECTION_ISFETCHING: {
      return {
        ...state,
        isListFetching: false,
        isObjectFetching: false
      };
    }
    case COLLECTION_LIST_REQUESTING: {
      return {
        ...state,
        isListFetching: true
      };
    }
    case LIST_COLLECTIONS_SUCCESS: {
      return {
        ...state,
        query: action.payload.data,
        isListFetching: false
      };
    }

    case GET_COLLECTION_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.collection.id] = action.payload.collection;
      return {
        ...state,
        data,
        isObjectFetching: false,
        recordCount: action.payload.total
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getCollectionBySlug = (collections, slug) => {
  if (!collections.data) {
    return null;
  }
  const collectionIds = Object.keys(collections.data);
  const collectionBySlugId = collectionIds.find(
    (id) => collections.data[id].slug === slug
  );
  if (collectionBySlugId) {
    return collections.data[collectionBySlugId];
  }
  return null;
};
